import { usePermissions } from './usePermissions';

/**
 * Hook للتحقق من صلاحيات كميات إعادة الطلب
 * يوفر دوال للتحقق من الصلاحيات المختلفة لصفحة كميات إعادة الطلب
 */
export const useReorderQuantityPermissions = () => {
  const { hasPermission } = usePermissions();

  // التحقق من صلاحية الوصول إلى صفحة كميات إعادة الطلب
  const hasAccessPermission = () => {
    return hasPermission('products', 'reorder-quantities', 'view_page');
  };

  // التحقق من صلاحية المزامنة
  const hasSyncPermission = () => {
    return hasPermission('products', 'reorder-quantities', 'sync');
  };

  // التحقق من صلاحية تحميل الكميات الحالية
  const hasDownloadPermission = () => {
    return hasPermission('products', 'reorder-quantities', 'download');
  };

  // التحقق من صلاحية رفع الملف المحدث
  const hasUploadPermission = () => {
    return hasPermission('products', 'reorder-quantities', 'upload');
  };

  // التحقق من صلاحية حفظ التغييرات
  const hasSavePermission = () => {
    return hasPermission('products', 'reorder-quantities', 'save');
  };

  // التحقق من صلاحية عرض البيانات
  const hasViewPermission = () => {
    return hasPermission('products', 'reorder-quantities', 'view');
  };

  return {
    hasAccessPermission,
    hasSyncPermission,
    hasDownloadPermission,
    hasUploadPermission,
    hasSavePermission,
    hasViewPermission
  };
};